import { Skeleton } from '@/components/ui/daisy';

const SKELETON_COUNT = 3;

export default function LessonProgressListSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: SKELETON_COUNT }, (_, index) => (
        <Skeleton key={index} className="h-24 w-full rounded-2xl" />
      ))}
    </div>
  );
}
